<template>
  <div>
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="4" :sm="24">
            <a-form-item label="飞机识别号">
              <a-input v-model="queryParam.number" placeholder="请输入" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="7" :sm="24">
            <a-form-item label="出入时间">
              <a-range-picker
                style="width:100%"
                @change="time"
                format="YYYY-MM-DD HH:mm:ss">
                <template slot="dateRender" slot-scope="current">
                  <div class="ant-calendar-date" :style="getCurrentStyle(current)">
                    {{ current.date() }}
                  </div>
                </template>
              </a-range-picker>
            </a-form-item>
          </a-col>
          <a-col :md="2" :sm="24">
            <a-button type="primary" icon="search" @click="$refs.table.refresh(true)">查询</a-button>
          </a-col>
          <a-col :md="1" :sm="24">
            <a-button type="primary" icon="plus" @click="handleAdd" v-action:add>新建</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <s-table
      ref="table"
      size="small"
      rowKey="id"
      :loading="loading"
      :columns="columns"
      :pageNum="pageNum"
      :data="loadData"
      :scroll="{ x: 1000 }"
    >
      <span slot="serial" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <span slot="image" slot-scope="img">
        <a-avatar
          slot="img"
          :src="img"
          shape="square"
          @click="openPreview(img)"
        />
      </span>
      <div slot="money_render" slot-scope="text" style="text-align: right; min-width: 120px; max-width: 140px">
        {{ (text / 100).toFixed(2) | numberFormat }}
      </div>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="openPreview(record.image)">查看</a>
          <a-divider type="vertical" v-if="!record.used" />
          <a @click="handleEdit(record)" v-if="!record.used" v-action:edit>编辑</a>
          <a-divider type="vertical" v-if="!record.used" />
          <a-popconfirm
            v-action:delete
            v-if="!record.used"
            title="确定要删除么？"
            ok-text="确定"
            cancel-text="取消"
            @confirm="handleDelete(record)">
            <a>删除</a>
          </a-popconfirm>
          <a-divider type="vertical" v-if="record.status === 0 && !record.used" />
          <a-popconfirm
            v-if="record.status === 0 && !record.used"
            title="确定生成缴费单吗？"
            ok-text="确定"
            cancel-text="取消"
            @confirm="handlePay(record)">
            <a>缴费单</a>
          </a-popconfirm>
        </template>
      </span>
    </s-table>
    <a-modal v-model="previewVisible" title="预览" width="450px" :footer="null">
      <img alt="example" style="width: 400px; margin: 0 auto" :src="previewUrl" />
    </a-modal>
    <create-form
      ref="createModal"
      :visible="visible"
      :loading="confirmLoading"
      @cancel="handleCreateCancel"
      @ok="handleCreateOk"
    />
  </div>
</template>

<script>
import { STable } from '@/components'
import { Dictionaries } from '@/common/AllConstant'
import CreateForm from '../modules/CreateForm'
import {
  monitor_plane_in_out_create,
  monitor_plane_in_out_delete,
  monitor_plane_in_out_list,
  monitor_plane_record_create
} from '@/api/monitor_plane'

export default {
  name: 'TableList',
  components: {
    STable,
    CreateForm
  },
  data () {
    return {
      pageNum: 1,
      dataSource: [],
      corporation_id: null,
      tip: '',
      corList: [],
      loading: false,
      confirmLoading: false,
      dictionaries: Dictionaries,
      previewUrl: '',
      previewVisible: false,
      // 创建窗口控制
      visible: false,
      mdl: {},
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          fixed: 'left',
          title: '序号',
          width: 50,
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '飞机识别号',
          dataIndex: 'number',
          width: 200,
          ellipsis: true
        },
        {
          title: '状态',
          dataIndex: 'status',
          align: 'center',
          width: 100,
          customRender: (text) => this.$Dictionaries.monitor_plane_in_out_status[text],
          ellipsis: true
        },
        {
          title: '出入时间',
          dataIndex: 'in_out_time',
          width: 180,
          ellipsis: true
        },
        {
          title: '操作人',
          dataIndex: 'create_by',
          width: 150,
          ellipsis: true
        },
        {
          title: '备注',
          dataIndex: 'remark',
          width: 180,
          ellipsis: true
        },
        {
          fixed: 'right',
          title: '操作',
          dataIndex: 'action',
          width: 200,
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        console.log('loadData.parameter', parameter)
        return monitor_plane_in_out_list(Object.assign(parameter, this.queryParam))
          .then(res => {
            console.log(res.data, '我是数据列表@')
            return res.data
          })
      },
      selectedRowKeys: [],
      selectedRows: []
    }
  },
  created () {
    this.setCurrentPage()
    const id = this.$route.params.id
    if (id) {
      this.queryParam.id = id
    }
  },
  methods: {
    time (dates, dateStrings) {
      console.log(dateStrings, '时间')
      this.queryParam.start_time = dateStrings[0]
      this.queryParam.end_time = dateStrings[1]
    },
    getCurrentStyle (current, today) {
      const style = {}
      if (current.date() === 1) {
        style.border = '1px solid #1890ff'
        style.borderRadius = '50%'
      }
      return style
    },
    setCurrentPage () {
      const page = this.$store.getters.pop
      if (page) {
        console.log('获取到的page：', page)
        const current = page.split('#$$#')[0]
        const query = page.split('#$$#')[1]
        const path = page.split('#$$#')[2]
        sessionStorage.removeItem('GuaranteeCurrentPage')
        if (path === this.$route.path) {
          if (!isNaN(Number(current))) {
            this.pageNum = Number(current)
          }
          if (query) {
            this.queryParam = JSON.parse(query)
          }
        } else {
          this.queryParam = {}
          this.$store.dispatch('clear')
        }
      } else {
        console.log('这是个空的page')
      }
    },
    handleAdd () {
      this.mdl = null
      this.visible = true
    },
    handleCreateCancel () {
      this.visible = false
      const form = this.$refs.createModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleCreateOk (image) {
      const form = this.$refs.createModal.form
      this.confirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values)
          // 新增
          if (image !== undefined) {
            values['image'] = image
          }
          if (typeof values['in_out_time'] === 'object') {
            values['in_out_time'] = values['in_out_time'].format('YYYY-MM-DD HH:mm:ss')
          }
          monitor_plane_in_out_create(values).then(res => {
            if (res.code === 1000) {
              this.$refs.table.refresh()
            }
          }).finally(() => {
            this.visible = false
            this.confirmLoading = false
            form.resetFields()
          })
        } else {
          this.confirmLoading = false
        }
      })
    },
    handleEdit (record) {
      this.$emit('onEdit', record)
    },
    handleDelete (record) {
      monitor_plane_in_out_delete(record.id).then((res) => {
        console.log(res)
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      })
    },
    handlePay (record) {
      console.log(record)
      monitor_plane_record_create(record).then(res => {
        if (res.code === 1000) {
          this.$message.success('成功生成缴费单')
          this.$refs.table.refresh()
        }
      })
    },
    openPreview (url) {
      if (url === undefined || url === '') {
        this.$message.warning('飞机图片不存在')
        return
      }
      this.previewVisible = true
      this.previewUrl = url
    }
  }
}
</script>
